import { render, staticRenderFns } from "./OrganisationsOverview.vue?vue&type=template&id=48d81af7"
import script from "./OrganisationsOverview.vue?vue&type=script&lang=js"
export * from "./OrganisationsOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports